export default (() => ({
  fileFields: [],

  init() {
    this.$el.querySelectorAll('input.wpcf7-file').forEach((input) => {
      this._upgradeFileInput(input);
    });

    // Re-clear custom UI when CF7 resets the form (e.g. after mailsent)
    this.$el.addEventListener('wpcf7mailsent', () => {
      this.fileFields.forEach((field) => {
        field.files = [];
        field.input.value = '';
        this._updateLabel(field);
      });
    });
  },

  _upgradeFileInput(input) {
    const wrap = input.closest('.wpcf7-form-control-wrap');
    if (!wrap) return;

    const fieldId = `cf7-file-${Math.random().toString(36).slice(2, 8)}`;
    const field = { input, files: [], id: fieldId };
    this.fileFields.push(field);

    // Hide the native input; keep it in the DOM for CF7 submission
    input.setAttribute('aria-hidden', 'true');
    input.classList.add('cf7-file__native');

    // Build custom UI
    const ui = document.createElement('div');
    ui.className = 'cf7-file';
    ui.innerHTML = `
      <label class="cf7-file__zone" for="${fieldId}" role="button" tabindex="0">
        <span class="cf7-file__placeholder">Add file or drop files here</span>
      </label>
      <ul class="cf7-file__list" aria-label="Selected files" hidden></ul>
    `;

    wrap.appendChild(ui);

    // Forward click from custom zone to hidden native input
    ui.querySelector('.cf7-file__zone').addEventListener('click', (e) => {
      e.preventDefault();
      input.click();
    });

    ui.querySelector('.cf7-file__zone').addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        input.click();
      }
    });

    // Handle file selection
    input.addEventListener('change', () => {
      field.files = Array.from(input.files);
      this._updateLabel(field);
    });

    // Drag-and-drop support
    const zone = ui.querySelector('.cf7-file__zone');

    zone.addEventListener('dragover', (e) => {
      e.preventDefault();
      zone.classList.add('is-dragover');
    });

    zone.addEventListener('dragleave', () => {
      zone.classList.remove('is-dragover');
    });

    zone.addEventListener('drop', (e) => {
      e.preventDefault();
      zone.classList.remove('is-dragover');

      const dt = e.dataTransfer;
      if (!dt || !dt.files.length) return;

      // Merge with current files unless input is single-file
      const existing = field.files;
      const incoming = Array.from(dt.files);
      field.files = input.multiple ? [...existing, ...incoming] : [incoming[0]];

      // Sync back to native input via DataTransfer
      this._syncNativeInput(input, field.files);
      this._updateLabel(field);
    });

    field._ui = ui;
  },

  _updateLabel(field) {
    const list = field._ui.querySelector('.cf7-file__list');
    const placeholder = field._ui.querySelector('.cf7-file__placeholder');

    list.innerHTML = '';

    if (field.files.length === 0) {
      // placeholder.hidden = false;
      list.hidden = true;
      return;
    }

    // placeholder.hidden = true;
    list.hidden = false;

    field.files.forEach((file, index) => {
      const li = document.createElement('li');
      li.className = 'cf7-file__item';
      li.innerHTML = `
        <span class="cf7-file__name">${this._escapeHtml(file.name)}</span>
        <button type="button" class="cf7-file__remove" aria-label="Remove ${this._escapeHtml(file.name)}">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M18 6 6 18M6 6l12 12"/>
          </svg>
        </button>
      `;
      li.querySelector('.cf7-file__remove').addEventListener('click', () => {
        this._removeFile(field, index);
      });
      list.appendChild(li);
    });
  },

  _removeFile(field, index) {
    field.files.splice(index, 1);
    if (field.files.length === 0) {
      field.input.value = '';
    } else {
      this._syncNativeInput(field.input, field.files);
    }
    this._updateLabel(field);
  },

  _syncNativeInput(input, files) {
    const dt = new DataTransfer();
    files.forEach((f) => dt.items.add(f));
    input.files = dt.files;
  },

  _escapeHtml(str) {
    return str.replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  },
}))
